const initializeMessagePolling = () => {
    const composer = document.querySelector(
        '[data-message-composer]'
    );

    const messageList = document.querySelector(
        '[data-message-list]'
    );

	const newMessagesButton =
    document.querySelector(
        '[data-new-messages-button]'
    );
	
    if (!composer || !messageList) {
        return;
    }

    const insertionPoint = messageList.querySelector(
        '[data-message-insertion-point]'
    );

    if (!insertionPoint) {
        return;
    }

    const updatesUrl =
        composer.dataset.messageUpdatesUrl;

    if (!updatesUrl) {
        return;
    }

    let latestMessageId = Number(
        messageList.dataset.latestMessageId ?? 0
    );

    let historyMode = false;

    const createMessageElement = (html) => {
        const template =
            document.createElement('template');

        template.innerHTML = html.trim();

        return template.content.firstElementChild;
    };
	
	const isNearBottom = () => {
    return (
        window.innerHeight +
        window.scrollY >=
        document.body.offsetHeight - 250
    );
};

    const poll = async () => {
        try {
            const response = await fetch(
                `${updatesUrl}?after_id=${latestMessageId}`,
                {
                    credentials: 'same-origin',
                    headers: {
                        Accept: 'application/json',
                        'X-Requested-With':
                            'XMLHttpRequest',
                    },
                }
            );

            if (!response.ok) {
                return;
            }

            const data = await response.json();

            const readReceipts =
                data.read_receipts ?? {};
            const reactions =
                data.reactions ?? {};
            const editedMessages =
                data.edited_messages ?? {};
            const deletedMessages =
                data.deleted_messages ?? {};

            Object.entries(reactions).forEach(
                ([messageId, reactionData]) => {
                    const message = document.getElementById(
                        `message-${messageId}`
                    );

                    if (!message) {
                        return;
                    }

                    const container =
                        message.querySelector(
                            '[data-message-reactions]'
                        );

                    if (
                        !container
                        || typeof window.updateMessageReactionUi
                        !== 'function'
                    ) {
                        return;
                    }

                    container.reactionMembersCache?.clear();

                    window.updateMessageReactionUi(
                        container,
                        reactionData
                    );
                }
            );

            Object.entries(editedMessages).forEach(
                ([messageId, editedMessage]) => {
                    const message = document.getElementById(
                        `message-${messageId}`
                    );

                    if (!message) {
                        return;
                    }

                    const body =
                        message.querySelector(
                            '[data-message-body]'
                        );

                    if (body) {
                        body.innerHTML =
                            editedMessage.body_html;
                    }

                    const edited =
                        message.querySelector(
                            '[data-message-edited]'
                        );

                    if (edited) {
                        edited.classList.toggle(
                            'hidden',
                            !editedMessage.edited
                        );
                    }
                }
            );

            Object.entries(deletedMessages).forEach(
                ([messageId, deletedMessage]) => {
                    const message =
                        document.getElementById(
                            `message-${messageId}`
                        );

                    if (!message) {
                        return;
                    }

                    if (
                        message.querySelector(
                            '[data-message-deleted]'
                        )
                    ) {
                        return;
                    }

                    const updatedElement =
                        createMessageElement(
                            deletedMessage.html
                        );

                    if (!updatedElement) {
                        return;
                    }

                    message.replaceWith(
                        updatedElement
                    );
                }
            );

            Object.entries(readReceipts).forEach(
                ([messageId, receipt]) => {
                    const message = document.getElementById(
                        `message-${messageId}`
                    );

                    if (!message) {
                        return;
                    }

                    const receiptElement =
                        message.querySelector(
                            '[data-message-read-receipt]'
                        );

                    if (!receiptElement) {
                        return;
                    }

                    receiptElement.textContent =
                        receipt.text;

                    receiptElement.classList.remove(
                        'text-cyan-100',
                        'text-white/60'
                    );

                    receiptElement.classList.add(
                        receipt.class
                    );
                }
            );

            if (!Array.isArray(data.messages)) {
                return;
            }

			const shouldAutoScroll =
    isNearBottom();

let receivedMessages = false;

            if (historyMode) {
                return;
            }
			
            for (const message of data.messages) {
                if (
                    document.getElementById(
                        `message-${message.id}`
                    )
                ) {
                    continue;
                }

                const element =
                    createMessageElement(
                        message.html
                    );

                if (!element) {
                    continue;
                }

                messageList.insertBefore(
                    element,
                    insertionPoint
                );

                latestMessageId = Math.max(
                    latestMessageId,
                    message.id
                );
                messageList.dataset.latestMessageId =
                    latestMessageId;

                receivedMessages = true;
            }
			if (!receivedMessages) {
    return;
}

if (shouldAutoScroll) {
    insertionPoint.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
    });

    newMessagesButton?.classList.add(
        'hidden'
    );
} else {
    newMessagesButton?.classList.remove(
        'hidden'
    );
}
			
        } catch {
            // Ignore temporary polling failures.
        }
    };
	
	newMessagesButton
    ?.querySelector('button')
    ?.addEventListener(
        'click',
        () => {
            insertionPoint.scrollIntoView({
                behavior: 'smooth',
                block: 'end',
            });

            newMessagesButton.classList.add(
                'hidden'
            );
        }
    );
			
			window.addEventListener(
    'scroll',
    () => {
        if (
            isNearBottom()
        ) {
            newMessagesButton?.classList.add(
                'hidden'
            );
        }
    },
    {
        passive: true,
    }
);

    window.addEventListener(
        'conversation-history-mode',
        (event) => {
            historyMode =
                Boolean(
                    event.detail?.active
                );
            if (!historyMode) {
                latestMessageId = Number(
                    messageList.dataset
                        .latestMessageId ?? 0
                );

                poll();
            }


            if (!historyMode) {
                newMessagesButton
                    ?.classList.add(
                    'hidden'
                );
            }
        }
    );

    setInterval(
        poll,
        2000
    );
};

if (document.readyState === 'loading') {
    document.addEventListener(
        'DOMContentLoaded',
        initializeMessagePolling
    );
} else {
    initializeMessagePolling();
}